<template>
    <div>
        <div class="nav-vertical">
			<ul class="nav nav-tabs nav-left" role="tablist">
                <li class="nav-item">
                  <a class="nav-link active" v-bind:href="'#t1'+rowData.modcte_id+''" role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      Detalhes
                      <i class="fa fa-plus"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" v-bind:href="'#t2'+rowData.modcte_id+''" role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      Carga
                      <i class="fa fa-user"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" v-bind:href="'#t3'+rowData.modcte_id+''" role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      Componente de frete
                      <i class="fa fa-user"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" v-bind:href="'#t4'+rowData.modcte_id+''" role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      Seguro
                      <i class="fa fa-user"></i>
                    </span>
                  </a>
                </li>
			</ul>

			<div class="tab-content">
        <div role="tabpanel" class="tab-pane fade in active show" v-bind:id="'t1'+rowData.modcte_id+''">
                        <table class="table" id="mais">
                            <thead>
                                <tr>
                                    <th style="width: 10%">CFOP</th>
                                    <th style="width: 10%">CST</th>
                                    <th style="width: 10%">Produto Predominante</th>
                                    <th style="width: 10%">Valor Averbação</th>
                                    <th style="width: 10%">Alq. ICMS</th>
                                    <th style="width: 10%">% Redução BC</th>
                                    <th style="width: 10%">Valor imposto</th>
                                    <th style="width: 30%">Observação</th>

                                </tr>
                             </thead>
                             <tbody>
                                 <tr class="bg-gray-light" style="display: table-row;">
                                    <td>
                                        {{ rowData.cfop.descr}}
                                    </td>
                                    <td>
                                        {{ rowData.param_cst.descr}}
                                    </td>
                                    <td>
                                        {{ rowData.produto_predominante}}
                                    </td>
                                    <td>
                                        {{ formatNumber(rowData.vlr_averbacao) }}
                                    </td>
                                    <td>
                                        {{ formatNumber(rowData.aliquota_icms) }}
                                    </td>
                                    <td>
                                        {{ formatNumber(rowData.percentual_reducao_bc) }}
                                    </td>
                                    <td>
                                        {{ formatNumber(rowData.vlr_imposto) }}
                                    </td>
                                    <td>
                                        {{ rowData.obs}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                </div><!--.tab-pane-->
                <div role="tabpanel" class="tab-pane fade" v-bind:id="'t2'+rowData.modcte_id+''">
                                <table class="table" id="mais">
                                    <thead>
                                        <tr>
                                            <th style="width: 35%">Unidade Medida</th>
                                            <th style="width: 35%">Tipo Medida</th>
                                            <th style="width: 30%">Quantidade</th>
                                        </tr>
                                     </thead>
                                     <tbody>
                                         <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.modelo_cte_carga">
                                            <td>
                                                {{ item.param_unidade_medida.descr }}
                                            </td>
                                            <td>
                                                {{ item.param_tipo_medida.descr}}
                                            </td>
                                            <td>
                                                {{ formatNumber(item.qtd) }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                        </div><!--.tab-pane-->
                        <div role="tabpanel" class="tab-pane fade" v-bind:id="'t3'+rowData.modcte_id+''">
                                        <table class="table" id="mais">
                                            <thead>
                                                <tr>
                                                    <th style="width: 80%">Componente</th>
                                                    <th style="width: 30%">Valor</th>
                                                </tr>
                                             </thead>
                                             <tbody>
                                                 <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.modelo_cte_comp_frete">
                                                    <td>
                                                        {{ item.custo.descr }}
                                                    </td>
                                                    <td>
                                                        {{ formatNumber(item.vlr) }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                </div><!--.tab-pane-->
                                <div role="tabpanel" class="tab-pane fade" v-bind:id="'t4'+rowData.modcte_id+''">
                                                <table class="table" id="mais">
                                                    <thead>
                                                        <tr>
                                                            <th style="width: 50%">Responsável pelo seguro</th>
                                                            <th style="width: 50%">Seguradora</th>
                                                        </tr>
                                                     </thead>
                                                     <tbody>
                                                         <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.modelo_cte_seguro">
                                                            <td>
                                                                {{ item.param_tipo_resp_seg.descr }}
                                                            </td>
                                                            <td>
                                                                {{ item.seguradora.nome }}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                        </div><!--.tab-pane-->
			</div><!--.tab-content-->
		</div>
    </div>
  </template>

  <script>
  import accounting from 'accounting'
  import moment from 'moment'
  export default {
      data () {
        return {
          helpForm: new Form({statusRecord: [], params: []}),
        }
    },
    props: {
      rowData: {
        type: Object,
        required: true
      },
      rowIndex: {
        type: Number
      }
    },
    methods: {
      formatNumber (value) {
          return accounting.formatNumber(value, 2, '.', ',')
      },
      formatDate (value, fmt = 'D/MM/YYYY HH:mm') {
        return (value == null)
          ? ''
          : moment(value, 'YYYY-MM-DD HH:mm').format(fmt)
      },
    },
  }
  </script>
